<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>{{ (mode === 'data-permohonan') ? 'Data Permohonan' : 'Riwayat Input' }}</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              {{ (mode === 'data-permohonan') ? 'Data Permohonan' : 'Riwayat Input' }}
            </div>
          </div>
        </div>
        <div class="section-body">
          <!-- widget filter status -->
          <ListPermohonanFilterStatus
            :mode="mode"
            :widget-status="widgetStatus"
            :show-filter-data="showFilter"
            :num-all-permohonan="numAllPermohonan"
            @filterStatus="filterStatus"
            @setShowFilter="setShowFilter"
          />
                    
          <hr>

          <!-- widget advanced filter -->
          <ListPermohonanAdvancedFilter
            :show-filter="showFilter"
            :filter-data="filter"
            :urut-dari-terbaru-data="urutDariTerbaru"
            :sort-by-desc-data="sortByDesc"
            :search-data="search"
            :per-page-data="per_page"
            @setAdvancedFilter="setAdvancedFilter"
            @hapusFilter="hapusFilter"
            @loadPermohonan="loadPermohonan"
          />

          <!-- list permohonan -->
          <ListPermohonanData
            :mode="mode"
            @loadPermohonan="loadPermohonan"
            @setCurrentPage="setCurrentPage"
          />
        </div>
      </section>
    </div>
  </LayoutAdmin>
</template>

<style scoped>
</style>

<script>
import _ from 'lodash'
import swal from 'sweetalert'
import LayoutAdmin from './../layouts/Admin.vue'
import ListPermohonanFilterStatus from './ListPermohonanFilterStatus.vue'
import ListPermohonanAdvancedFilter from './ListPermohonanAdvancedFilter.vue'
import ListPermohonanData from './ListPermohonanData.vue'

export default {
  data() {
    return {
      widgetStatus: null,
      numAllPermohonan: 0,

      // list nama status, 0,1,2,3 dst
      namaStatus: [
        'Belum Diajukan',
        'Diajukan ke Desa',
        'Diproses di Desa',
        'Revisi tingkat Desa',
        'Ditolak Desa',
        'Diajukan ke Kecamatan',
        'Diproses di Kecamatan',
        'Revisi tingkat Kecamatan',
        'Ditolak Kecamatan',
        'Diajukan ke Dukcapil',
        'Diproses di Dukcapil',
        'Revisi tingkat Dukcapil',
        'Ditolak Dukcapil',
        'Dibatalkan',
        'Selesai',
      ],
      showFilter: false,
      current_page: 1,
      per_page: 5,
      search: '',
      sortBy: 'created_at',
      sortByDesc: true,
      tableLoading: true,

      urutDariTerbaru: 1, // v-model untuk sortByDesc, 0=yg lama muncul dulu, 1=yg baru muncul duluan

      filter: {
        id_kecamatan: { id_kecamatan: 0, nama_kecamatan: 'SEMUA KECAMATAN' },
        id_desa: { id_desa: 0, nama_desa: 'SEMUA DESA' },
        id_layanan: { id_layanan: 0, nama_layanan: 'SEMUA LAYANAN' },
        tanggal_start: '',
        tanggal_end: '',
        status: null
      },
      meta: {
        current_page: 1,
        per_page: 10,
        from: null,
        to: null,
        total: null
      },
      hasSetDefaultFilter: false, // supaya setting default filter hanya sekali diawal

    }
  },
  computed: {
    permohonan() {
      return this.$store.getters.getPermohonan
    },
    metaPermohonan() {
      return this.$store.getters.getMetaPermohonan
    },
    filterPermohonan() {
      return this.$store.getters.getFilterPermohonan
    },
    dataPermohonan() { // untuk watch, untuk show yang belum diajukan, mau select paket, layanan dll
      return this.$store.getters.getDataPermohonan
    },
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  props: {
    mode: {
      type: String,
      default: () => null
    }
  },
  components: {
    LayoutAdmin, ListPermohonanFilterStatus, ListPermohonanAdvancedFilter, ListPermohonanData
  },
  methods: {
    loadPermohonan() {
      this.$store.dispatch('setPermohonan', null)


      let dispatchPermohonan = ''
      switch (this.namaRole) {
        case 'Penduduk':
          // dispatchPermohonan = 'fetchPermohonanPenduduk'
          dispatchPermohonan = 'fetchPaginatePermohonanPenduduk'
          break

        case 'Operator Desa':
          // dispatchPermohonan = 'fetchPermohonanDesa'
          dispatchPermohonan = 'fetchPaginatePermohonanDesa'
          if (this.mode === 'riwayat-input') {
            dispatchPermohonan = 'fetchRiwayatInputDesa'
          }
          break


        case 'Kepala Desa':
          // dispatchPermohonan = 'fetchPermohonanDesa'
          dispatchPermohonan = 'fetchPaginatePermohonanDesa'
          if (this.mode === 'riwayat-input') {
            dispatchPermohonan = 'fetchRiwayatInputDesa'
          }
          break

        case 'Operator Kecamatan':
          // dispatchPermohonan = 'fetchPermohonanKecamatan'
          dispatchPermohonan = 'fetchPaginatePermohonanKecamatan'
          break

        case 'Operator Dukcapil Kecamatan':
          // dispatchPermohonan = 'fetchPermohonanDukcapil'
          dispatchPermohonan = 'fetchPaginatePermohonanDukcapil'
          break

        case 'Operator Dukcapil':
          // dispatchPermohonan = 'fetchPermohonanDukcapil'
          dispatchPermohonan = 'fetchPaginatePermohonanDukcapil'
          break
        
        case 'Admin Laksita':
          // dispatchPermohonan = 'fetchPermohonanDukcapil'
          dispatchPermohonan = 'fetchPaginatePermohonanDukcapil'
          break
        
        case 'Admin Jembrana':
          // dispatchPermohonan = 'fetchPermohonanDukcapil'
          dispatchPermohonan = 'fetchPaginatePermohonanDukcapil'
          break
          
        case 'Rumah Sakit':
          // dispatchPermohonan = 'fetchPermohonanDukcapil'
          dispatchPermohonan = 'fetchPaginatePermohonanRumahSakit'
          if (this.mode === 'riwayat-input') {
            dispatchPermohonan = 'fetchRiwayatInputRumahSakit'
          }
          break
      }

      let filter = this.$store.getters.getFilterPermohonan

      let current_page = this.search == '' ? this.meta.current_page : 1
      let data = {
        page: current_page,
        per_page: this.per_page,
        q: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC' : 'ASC',
        status: null
      }

      data.status = filter.status

      if (this.namaRole != 'Penduduk') {
        if (this.filter.id_layanan.id_layanan != 0) {
          data.id_layanan = this.filter.id_layanan.id_layanan
        }
      }

      const roleFilterIdDesa = ['Operator Kecamatan', 'Operator Dukcapil', 'Operator Dukcapil Kecamatan', 'Admin Laksita', 'Admin Jembrana']
      if (roleFilterIdDesa.includes(this.namaRole)) {
        if (this.filter.id_desa.id_desa != 0) {
          data.id_desa = this.filter.id_desa.id_desa
        }
      }
      const roleFilterIdKecamatan = ['Operator Dukcapil', 'Operator Dukcapil Kecamatan', 'Admin Laksita', 'Admin Jembrana']
      if (roleFilterIdKecamatan.includes(this.namaRole)) {
        if (this.filter.id_kecamatan.id_kecamatan != 0) {
          data.id_kecamatan = this.filter.id_kecamatan.id_kecamatan
        }
      }

      if (this.filter.tanggal_start) {
        data.tanggal_start = this.filter.tanggal_start
        data.tanggal_end = this.filter.tanggal_end
      }

      this.$store.dispatch(dispatchPermohonan, data).then(res => {
        // console.log(res)
        if (res.data.status) {
          this.$store.dispatch('setPermohonan', res.data.data.data)
          this.meta = {
            total: res.data.data.total,
            current_page: res.data.data.current_page,
            per_page: parseInt(res.data.data.per_page),
            from: res.data.data.from,
            to: res.data.data.to
          }
          // console.log('meta after load', this.meta)
          this.$store.commit('SET_META_PERMOHONAN', this.meta)
          this.$store.dispatch('setPermohonan', res.data.data.data)
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      }).catch(err => {
        // console.log('err', err)
        // console.log('err.response', err.response)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 401:
            this.$store.dispatch('logoutUser')
            window.location = '/login'
            break

          case 400:
            swal({
              title: 'Gagal',
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: 'error',
              buttons: 'Ok'
            })
            break;

          default:
            swal({
              title: 'Gagal',
              text: err.response.data.message,
              icon: 'error',
              buttons: 'Ok'
            })
            break;
        }
      })

      this.createWidgetStatus()
    },
    createWidgetStatus() {
      let dispatchStatus = 'getAllStatusPermohonanPenduduk'
      let dispatchData = {}
      switch (this.namaRole) {
        case 'Penduduk':
          dispatchStatus = 'getAllStatusPermohonanPenduduk'
          break

        case 'Operator Desa':
          dispatchStatus = 'getAllStatusPermohonanDesa'
          if (this.mode === 'riwayat-input') {
            dispatchStatus = 'getAllStatusPermohonanDesaRiwayatInput'
          }
          break

        case 'Kepala Desa':
          dispatchStatus = 'getAllStatusPermohonanDesa'
          if (this.mode === 'riwayat-input') {
            dispatchStatus = 'getAllStatusPermohonanDesaRiwayatInput'
          }
          if (this.filter.id_desa.id_desa != 0) {
            dispatchData.id_desa = this.filter.id_desa.id_desa
          }
          break

        case 'Operator Kecamatan':
          dispatchStatus = 'getAllStatusPermohonanKecamatan'
          break

        case 'Operator Dukcapil Kecamatan':
          dispatchStatus = 'getAllStatusPermohonanDukcapil'
          if (this.filter.id_kecamatan.id_kecamatan != 0) {
            dispatchData.id_kecamatan = this.filter.id_kecamatan.id_kecamatan
          }
          if (this.filter.id_desa.id_desa != 0) {
            dispatchData.id_desa = this.filter.id_desa.id_desa
          }
          break

        case 'Operator Dukcapil':
          dispatchStatus = 'getAllStatusPermohonanDukcapil'
          if (this.filter.id_kecamatan.id_kecamatan != 0) {
            dispatchData.id_kecamatan = this.filter.id_kecamatan.id_kecamatan
          }
          if (this.filter.id_desa.id_desa != 0) {
            dispatchData.id_desa = this.filter.id_desa.id_desa
          }
          break
        
        case 'Admin Laksita':
          dispatchStatus = 'getAllStatusPermohonanDukcapil'
          if (this.filter.id_kecamatan.id_kecamatan != 0) {
            dispatchData.id_kecamatan = this.filter.id_kecamatan.id_kecamatan
          }
          if (this.filter.id_desa.id_desa != 0) {
            dispatchData.id_desa = this.filter.id_desa.id_desa
          }
          break
        
        case 'Admin Jembrana':
          dispatchStatus = 'getAllStatusPermohonanDukcapil'
          if (this.filter.id_kecamatan.id_kecamatan != 0) {
            dispatchData.id_kecamatan = this.filter.id_kecamatan.id_kecamatan
          }
          if (this.filter.id_desa.id_desa != 0) {
            dispatchData.id_desa = this.filter.id_desa.id_desa
          }
          break
        
        case 'Rumah Sakit':
          dispatchStatus = 'getAllStatusPermohonanRumahSakit'
          if (this.mode === 'riwayat-input') {
            dispatchStatus = 'getAllStatusPermohonanRumahSakitRiwayatInput'
          }
          break
      }

      this.$store.dispatch(dispatchStatus, dispatchData).then(res => {
        // console.log(res)
        if (res.data.status) {
          let arrStatus = res.data.data.map(e => e.status)
          this.numAllPermohonan = arrStatus.length
          let arrObj = []
          arrStatus.forEach((e, i) => {
            if (arrObj.findIndex(f => f.status === e) === -1) {
              arrObj.push({
                id: i,
                status: e,
                num: 1
              })
            } else {
              let idx = arrObj.findIndex(f => f.status === e)
              arrObj[idx].num = arrObj[idx].num + 1
            }
          })

          // console.log(arrObj)

          this.widgetStatus = arrObj

          // set Default Filter
          // this.setDefaultFilter()
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      }).catch(err => {
        // console.log(err)
        switch (err.response.status) {
          case 500:
            this.$router.push({ path: '/500' })
            break;

          case 400:
            swal({
              title: 'Gagal',
              text: (typeof (err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
              icon: 'error',
              buttons: 'Ok'
            })
            break;

          default:
            swal({
              title: 'Gagal',
              text: err.response.data.message,
              icon: 'error',
              buttons: 'Ok'
            })
            break;
        }
      })
    },
    setDefaultFilter() {

      /* 
       * rule nya:
       * - prioritas default untuk penduduk 'Belum Diproses', 'Revisi'
       * - untuk operator: 'Belum Diproses', 'Sedang Diproses'
       * - jika belum ada data dan tidak memenuhi semua rule, set ke filter semua
       */
      if (!this.hasSetDefaultFilter) {
        this.hasSetDefaultFilter = true

        let defaultFilterStatus = null
        if (this.namaRole === 'Penduduk') {
          // jika ada permohonan yg belum diproses, set default ke belum diproses
          if (this.widgetStatus.findIndex(e => e.status === 0) != -1) {
            defaultFilterStatus = 0
          } else if (this.widgetStatus.findIndex(e => e.status === 2) != -1) {
            // revisi desa
            defaultFilterStatus = 2
          } else {
            // tidak memenuhi semua kondisi, filter semua
            defaultFilterStatus = null
          }
        } else if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
          if (this.widgetStatus.findIndex(e => e.status === 1) != -1) {
            defaultFilterStatus = 1
          } else if (this.widgetStatus.findIndex(e => e.status === 2) != -1) {
            // revisi desa
            defaultFilterStatus = 2
          } else {
            // tidak memenuhi semua kondisi, filter semua
            defaultFilterStatus = null
          }
        } else if (this.namaRole === 'Operator Kecamatan') {
          if (this.widgetStatus.findIndex(e => e.status === 5) != -1) {
            defaultFilterStatus = 5
          } else if (this.widgetStatus.findIndex(e => e.status === 6) != -1) {
            // revisi kec
            defaultFilterStatus = 6
          } else {
            // tidak memenuhi semua kondisi, filter semua
            defaultFilterStatus = null
          }
        } else if (
          this.namaRole === 'Operator Dukcapil' ||
          this.namaRole === 'Operator Dukcapil Kecamatan' ||
          this.namaRole === 'Admin Laksita' ||
          this.namaRole === 'Admin Jembrana'
        ) {
          if (this.widgetStatus.findIndex(e => e.status === 9) != -1) {
            defaultFilterStatus = 9
          } else if (this.widgetStatus.findIndex(e => e.status === 10) != -1) {
            // revisi dukc
            defaultFilterStatus = 10
          } else {
            // tidak memenuhi semua kondisi, filter semua
            defaultFilterStatus = null
          }
        }


        this.filterStatus(defaultFilterStatus)
      }
    },
    setShowFilter (data) {
      this.showFilter = data
    },
    setCurrentPage (data) {
      this.meta.current_page = parseInt(data)
      this.loadPermohonan()
    },
    filterStatus(s) {
      let filter = this.$store.getters.getFilterPermohonan
      filter.status = s
      this.$store.dispatch('setFilterPermohonan', filter)

      // this.$store.dispatch('filterPermohonan')
      this.loadPermohonan()
    },
    hapusFilter() {
      this.sortByDesc = true
      this.search = ''
      this.showFilter = false
      this.filter = {
        id_kecamatan: { id_kecamatan: 0, nama_kecamatan: 'SEMUA KECAMATAN' },
        id_desa: { id_desa: 0, nama_desa: 'SEMUA DESA' },
        id_layanan: { id_layanan: 0, nama_layanan: 'SEMUA LAYANAN' },
        tanggal_start: '',
        tanggal_end: '',
        status: 0
      }
      this.loadPermohonan()
    },
    setAdvancedFilter (data) {
      this.filter = data.filter
      this.urutDariTerbaru = data.urutDariTerbaru
      this.sortByDesc = data.sortByDesc
      this.search = data.search
      this.per_page = data.per_page
    },
    // searchData: _.debounce(function (e) {
    //     //KIRIM EMIT DENGAN NAMA SEARCH DAN VALUE SESUAI YANG DIKETIKKAN OLEH USER
    //     // this.$emit('search', e.target.value)
    //     this.search = e.target.value
    //     this.loadPermohonan()
    // }, 500),
    // loadPerPage(val) {
    //     //DAN KITA EMIT LAGI DENGAN NAMA per_page DAN VALUE SESUAI PER_PAGE YANG DIPILIH
    //     // this.$emit('per_page', this.meta.per_page)
    //     // this.per_page = val
    //     this.loadPermohonan()
    // },
    // loadChangeUrut(){
    //     if(this.urutDariTerbaru == 0){
    //         // kalau 0 brrti urut dari lama
    //         this.sortByDesc = false
    //     } else if(this.urutDariTerbaru == 1){
    //         // kalau 1 brrti urut dari terbaru
    //         this.sortByDesc = true

    //     }
    //     this.loadPermohonan()
    // },
  },
  mounted() {
    if (this.permohonan.length === 0) {
      this.loadPermohonan()
    } else {
      this.createWidgetStatus()
    }
  },
  watch: {
    dataPermohonan(newVal) {
      // supaya permohonan tidak reset
      this.$store.dispatch('setIsResetPermohonan', false)

      // select paket
      this.$store.dispatch('selectPaket', newVal.paket_layanan.paket)

      // select layanan
      let layananSelect = newVal.paket_layanan.layanan
      layananSelect.paket_layanan = layananSelect.paket_layanan[0]
      this.$store.dispatch('selectLayanan', layananSelect)

      if (newVal.id_operator_pembantu) {
        if (['Operator Desa', 'Kepala Desa', 'Rumah Sakit'].includes(this.namaRole)) {
          this.$store.dispatch('setPendudukBantu', newVal.penduduk)
        }
      }

      // console.log(newVal)
      this.$router.push({ path: '/permohonan/buat-permohonan' })
    }
  }
}
</script>